import * as React from 'react'
import { connect } from 'react-redux'
import { getVoices } from '../Voices.actions'
import { VoiceRecordingSelectComponent } from './VoiceRecordingSelect'
import { IVoicesState } from '../Voices.reducer'
import { values, map, flow } from 'lodash/fp'
import { WrappedFieldProps } from 'redux-form'
import { showVoiceCreateModal } from '../VoiceCreateModal'
import showFileUploadModal from 'features/Files/FileUploadModal'

export type IVoiceRecordingSelectProps = WrappedFieldProps

const stateToProps = ({ voices }: { voices: IVoicesState }) => {
  return {
    results: flow(values, map('data'))(voices.byId),
  }
}

export const dispatchToProps = {
  getVoices,
  showVoiceCreateModal,
  showFileUploadModal,
}

export const VoiceRecordingSelect = connect(
  stateToProps,
  dispatchToProps
)(VoiceRecordingSelectComponent) as React.SFC<IVoiceRecordingSelectProps>



// WEBPACK FOOTER //
// src/features/Voices/VoiceRecordingSelect/VoiceRecordingSelect.container.ts